import { render, staticRenderFns } from "./PaperCard.vue?vue&type=template&id=b864b98c&scoped=true"
import script from "./PaperCard.vue?vue&type=script&lang=js"
export * from "./PaperCard.vue?vue&type=script&lang=js"
import style0 from "./PaperCard.vue?vue&type=style&index=0&id=b864b98c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b864b98c",
  null
  
)

export default component.exports